/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ShowDemosComponent } from '@src/app/modules/public/demos/show-demos/show-demos.component';
import { GetDemoAccessComponent } from '@src/app/modules/public/demos/get-demo-access/get-demo-access.component';
import { LeadProfileService } from '@src/app/modules/public/lead-profile.service';
import { CurrentUserService } from '@src/app/modules/user/current-user.service';


export type ApprovalStatus = 'yes' | 'no' | 'request' | 'hasCode'
@Component({
    selector: 'app-demos',
    imports: [ShowDemosComponent, GetDemoAccessComponent],
    templateUrl: './demos.component.html',
    styleUrl: './demos.component.scss'
})
export class DemosComponent {

    entryApproved: ApprovalStatus = 'no';
    lps = inject(LeadProfileService);

    constructor() {
        const cus = inject(CurrentUserService);

        if (this.lps.profile.validated) {
            this.entryApproved = 'yes';
        }
        cus.getCurrentUser().pipe(takeUntilDestroyed()).subscribe( u => {
            if (u) {
                this.entryApproved = 'yes';
            }
        })
    }
    
    giveUp() {
        this.entryApproved = 'no';
    }

    allowEntry() {
        this.entryApproved = 'yes';
    }

    requestAccessEvent(hasCode) {
        console.log({hasCode})
        if (hasCode) {
            this.entryApproved = 'hasCode';
        } else {
            this.entryApproved = 'request';
        }

    }
}
